import React from 'react';

interface Props {
  className?: string;
}
export default function PauseIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 6C10 5.44772 9.55228 5 9 5H8C7.44772 5 7 5.44772 7 6V18C7 18.5523 7.44772 19 8 19H9C9.55228 19 10 18.5523 10 18V6Z"
        fill="currentColor"
      />
      <path
        d="M17 6C17 5.44772 16.5523 5 16 5H15C14.4477 5 14 5.44772 14 6V18C14 18.5523 14.4477 19 15 19H16C16.5523 19 17 18.5523 17 18V6Z"
        fill="currentColor"
      />
    </svg>
  );
}
